/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramChatsUserControllerReadMessagesMutationRequest,
  TelegramChatsUserControllerReadMessagesMutationResponse,
  TelegramChatsUserControllerReadMessagesPathParams,
  TelegramChatsUserControllerReadMessages401,
  TelegramChatsUserControllerReadMessages403,
  TelegramChatsUserControllerReadMessages404,
} from '../types/TelegramChatsUserControllerReadMessages.ts';

function getTelegramChatsUserReadMessagesUrl(id: TelegramChatsUserControllerReadMessagesPathParams['id']) {
  const res = { method: 'POST', url: `/api/user/telegram/chats/${id}/read-messages` as const };
  return res;
}

/**
 * {@link /api/user/telegram/chats/:id/read-messages}
 */
export async function telegramChatsUserReadMessages(
  id: TelegramChatsUserControllerReadMessagesPathParams['id'],
  data: TelegramChatsUserControllerReadMessagesMutationRequest,
  config: Partial<RequestConfig<TelegramChatsUserControllerReadMessagesMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramChatsUserControllerReadMessagesMutationResponse,
    ResponseErrorConfig<
      | TelegramChatsUserControllerReadMessages401
      | TelegramChatsUserControllerReadMessages403
      | TelegramChatsUserControllerReadMessages404
    >,
    TelegramChatsUserControllerReadMessagesMutationRequest
  >({
    method: 'POST',
    url: getTelegramChatsUserReadMessagesUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
